import React, { FC } from 'react';
import { LOCATION_TYPE } from '../../../redux/api/load/load.model';
import TwAutocomplete, {
  TwAutocompleteOption
} from '../../../components/TwAutocomplete/TwAutocomplete';
import { FormikErrors, FormikValues } from 'formik';
import { CreateLocationFormValues } from '../CreateLocation/CreateLocation';
import { usePortCodeOptions } from '../../../hooks/usePortOfEntryOptions';

interface PortOfEntryFieldProps {
  values: CreateLocationFormValues;
  setFieldValue: FormikValues['setFieldValue'];
}

export const PortOfEntryField: FC<PortOfEntryFieldProps> = ({ values, setFieldValue }) => {
  const { usPorts, caPorts } = usePortCodeOptions();

  return values.type?.value === LOCATION_TYPE.US_PORT ||
    values.type?.value === LOCATION_TYPE.CA_PORT ? (
    <TwAutocomplete
      id="port_code"
      name="port_code"
      label="Location"
      optionList={values.type?.value === LOCATION_TYPE.US_PORT ? usPorts : caPorts}
      value={values.port_code}
      sortList={false}
      onChange={(
        _,
        newValue: TwAutocompleteOption | null
      ): Promise<void> | Promise<FormikErrors<CreateLocationFormValues>> => {
        return setFieldValue('port_code', newValue);
      }}
    />
  ) : null;
};
